






























































import { defineComponent, computed } from '@vue/composition-api';
import { useRouter, useRoute } from 'vue2-helpers/vue-router';
import { createVuexHelpers } from 'vue2-helpers';
// import { PlanList } from '@/prioritization/interface/interface';
import { VueInstance } from '@/main';
const { useState, useGetters } = createVuexHelpers();
import { profile } from '@/Utils/profile';
import { PlanList } from '@/prioritization/interface/interface';
const isRunOptimizationVisible = profile.get('isRunOptimizationVisible') === 'true';

const iesResilienceEval = profile.get('iesResilienceEval') === 'true';

const ieslabGmm = profile.get('ieslabGmm') === 'true';
const ieslabScheme = profile.get('ieslabScheme') === 'true';
const ieslabEvaluate = profile.get('ieslabEvaluate') === 'true';
const ieslabDigitalTwins = profile.get('ieslabDigitalTwins') === 'true';
const ieslabResilienceEval = profile.get('ieslabResilienceEval') === 'true';
const ieslabResiliencePlan = profile.get('ieslabResiliencePlan') === 'true';
const ieslabResilienceRecovery = profile.get('ieslabResilienceRecovery') === 'true';
const ieslabResilienceGenerate = profile.get('ieslabResilienceGenerate') === 'true';

export default defineComponent({
    setup(_props) {
        const router = useRouter();
        const route = useRoute();
        const commonList = computed(() => {
            const d = [
                { name: '数据管理', icon: 'iconshujuguanli', value: 'data', path: '/header/data', visable: true },
                { name: '拓扑编辑', icon: 'icontuoputu', value: 'diagram', path: '/diagram', visable: true },
                { name: '规划典型日生成', icon: 'iconfangan', value: 'gmm', path: '/gmm', visable: ieslabGmm },
                { name: '方案优选', icon: 'iconfangan1', value: 'scheme', path: '/header/scheme', visable: ieslabScheme },
                { name: '方案评估', icon: 'iconpinggu1', value: 'evaluate', path: '/header/evaluate', visable: ieslabEvaluate },
                { name: '数字孪生体交付', icon: 'iconshuzi', value: 'digitalTwins', path: '/header/digitalTwins', visable: ieslabDigitalTwins },
            ];

            if (iesResilienceEval) {
                d.push(
                    ...[
                        { name: '危机场景生成', icon: 'iconfangan', value: 'scenario-generate', path: '/scenario-generate', visable: ieslabResilienceGenerate },
                        { name: '韧性评估', icon: 'iconfangan', value: 'resilience-eval', path: '/resilience-eval', visable: ieslabResilienceEval },
                        { name: '韧性规划', icon: 'iconfangan', value: 'resilience-plan', path: '/resilience-plan', visable: ieslabResiliencePlan },
                        { name: '灾后恢复', icon: 'iconfangan', value: 'resilience-recovery', path: '/resilience-recovery', visable: ieslabResilienceRecovery },
                    ],
                );
            }
            return d;
        });

        const iesList = computed(() => {
            if (isRunOptimizationVisible) {
                return [
                    { name: '数据管理', icon: 'iconshujuguanli', value: 'ies-data', path: '/ies/header/data', visable: true },
                    { name: '拓扑编辑', icon: 'icontuoputu', value: 'ies/diagram', path: '/ies/diagram', visable: true },
                    { name: '仿真模拟', icon: 'iconfangan', value: 'ies/run-simulation', path: '/ies/run-simulation', visable: true },
                    { name: '运行优化', icon: 'iconshuzi', value: 'ies/run-optimization', path: '/ies/run-optimization', visable: true },
                ];
            } else {
                return [
                    { name: '数据管理', icon: 'iconshujuguanli', value: 'ies-data', path: '/ies/header/data', visable: true },
                    { name: '拓扑编辑', icon: 'icontuoputu', value: 'ies/diagram', path: '/ies/diagram', visable: true },
                    { name: '仿真模拟', icon: 'iconfangan', value: 'ies/run-simulation', path: '/ies/run-simulation', visable: true },
                ];
            }
        });
        const { iesMode, navigationRecords } = useState(['iesMode', 'navigationRecords']);
        // const iesMode = VueInstance.$store.state.iesMode;
        // const navigationRecords = VueInstance.$store.state.navigationRecords;
        const { getPlanList: planList, getCurrentPlanId: currentPlanId } = useGetters(['getPlanList', 'getCurrentPlanId']) as unknown as {
            getPlanList: PlanList[];
            getCurrentPlanId: number;
        };
        // const pList = VueInstance.$store.getters.getPlanList;
        // console.log(pList);
        // const currentPlanId = computed(() => VueInstance.$store.getters.getCurrentPlanId);

        // const { setCurrentPlanId } = useMutations(['setCurrentPlanId']) as Record<string, (i: number) => void>;
        const setCurrentPlanId = (i: number): void => {
            VueInstance.$store.commit('setCurrentPlanId', i);
        };
        // const getters = mapGetters(['getPlanList']);
        // console.log(getters);
        // console.log(getters.getPlanList);
        // console.log(computed(getters.getPlanList));

        const list = computed(() => (iesMode.value ? iesList.value : commonList.value));

        const isActive = (value: string): boolean => route.path.startsWith(value);

        const openPage = (value: string): void => {
            const query = route.query;

            const navigationRecord = navigationRecords.value[value];
            let name = value;
            //如果记录存在则替换name
            if (navigationRecord != null && navigationRecord !== '') {
                name = navigationRecord;
            }
            const r = {
                name: name,
                query: query,
            };

            void router.push(r).catch((e: Error) => {
                console.log(e);
            });
        };
        const openPlan = (navigation: string, it: PlanList): void => {
            setCurrentPlanId(it.id);
            openPage(navigation);
        };
        return {
            list,
            isActive,
            openPage,
            planList,
            currentPlanId,
            openPlan,
        };
    },
});
